export default {"src":"/_next/static/media/close.8d3f912f.svg","height":960,"width":960,"blurWidth":0,"blurHeight":0};